/* ============================================================
   Sommeliers of Amsterdam — theme behaviour.
   Ported from the Astro site's client scripts: hover/focus style states,
   sticky nav, scroll reveal, slideshows and the hero video reel.
   The enquiry form is now a real Shopify contact form, so its success
   state is rendered server-side and needs no JS.
   ============================================================ */
(function () {
  // Emulate DC style-hover / style-focus (kept until the UI is redesigned)
  function bindStyleStates() {
    // Only bind hover effects on devices that actually have a hover pointer —
    // on touch screens mouseenter fires on tap and mouseleave may not, leaving
    // buttons stuck in their hover state.
    var canHover = window.matchMedia('(hover: hover)').matches;
    if (canHover) {
      document.querySelectorAll('[data-hover]').forEach(function (el) {
        if (el.dataset.soaBound) return;
        el.dataset.soaBound = '1';
        var base = el.getAttribute('style') || '';
        var hover = el.getAttribute('data-hover') || '';
        el.addEventListener('mouseenter', function () { el.setAttribute('style', base + ';' + hover); });
        el.addEventListener('mouseleave', function () { el.setAttribute('style', base); });
      });
    }
    document.querySelectorAll('[data-focus]').forEach(function (el) {
      if (el.dataset.soaFocusBound) return;
      el.dataset.soaFocusBound = '1';
      var base = el.getAttribute('style') || '';
      var focus = el.getAttribute('data-focus') || '';
      el.addEventListener('focus', function () { el.setAttribute('style', base + ';' + focus); });
      el.addEventListener('blur', function () { el.setAttribute('style', base); });
    });
  }

  // Sticky nav appearance on scroll. Outside the homepage there is no hero
  // behind it, so the nav stays solid from the top.
  function bindNav() {
    var nav = document.getElementById('soa-nav');
    if (!nav) return;
    var alwaysSolid = !document.body.classList.contains('soa-home');
    var onScroll = function () {
      var s = alwaysSolid || window.scrollY > 40;
      nav.style.background = s ? 'rgba(33,22,17,0.94)' : 'transparent';
      nav.style.borderBottomColor = s ? 'rgba(231,211,189,0.14)' : 'transparent';
      nav.style.backdropFilter = s ? 'blur(10px)' : 'none';
      nav.style.webkitBackdropFilter = s ? 'blur(10px)' : 'none';
      nav.style.boxShadow = s ? '0 1px 0 rgba(0,0,0,0.25)' : 'none';
      nav.style.height = s && !alwaysSolid ? '66px' : '78px';
    };
    onScroll();
    if (!alwaysSolid) window.addEventListener('scroll', onScroll, { passive: true });
  }

  // Scroll reveal
  function bindReveal() {
    var els = Array.prototype.slice.call(document.querySelectorAll('[data-reveal]'));
    var reveal = function (el) { el.style.opacity = '1'; el.style.transform = 'none'; };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (ents) {
        ents.forEach(function (e) { if (e.isIntersecting) { reveal(e.target); io.unobserve(e.target); } });
      }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
      els.forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < window.innerHeight && r.bottom > 0) reveal(el);
        else io.observe(el);
      });
      setTimeout(function () { els.forEach(reveal); }, 1800); // safety net
    } else {
      els.forEach(reveal);
    }
  }

  // Cross-fade slideshows
  function initSlideshows() {
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    document.querySelectorAll('[data-slideshow]').forEach(function (el) {
      if (el.dataset.soaSsBound) return;
      el.dataset.soaSsBound = '1';
      var slides = Array.prototype.slice.call(el.querySelectorAll('.soa-ss-slide'));
      var dots = Array.prototype.slice.call(el.querySelectorAll('.soa-ss-dot'));
      if (slides.length < 2) return;
      var i = 0;
      var timer = 0;
      var interval = Number(el.getAttribute('data-interval')) || 4800;
      var go = function (n) {
        slides[i].classList.remove('is-active');
        if (dots[i]) dots[i].classList.remove('is-active');
        i = (n + slides.length) % slides.length;
        slides[i].classList.add('is-active');
        if (dots[i]) dots[i].classList.add('is-active');
      };
      var stop = function () { if (timer) { clearInterval(timer); timer = 0; } };
      var start = function () { if (reduce) return; stop(); timer = window.setInterval(function () { go(i + 1); }, interval); };
      dots.forEach(function (d, idx) { d.addEventListener('click', function () { go(idx); start(); }); });
      el.querySelectorAll('[data-dir]').forEach(function (b) {
        b.addEventListener('click', function () { go(i + Number(b.getAttribute('data-dir'))); start(); });
      });
      el.addEventListener('mouseenter', stop);
      el.addEventListener('mouseleave', start);
      start();
    });
  }

  // Hero video: the reels play back-to-back and loop, muted, as a background.
  //
  // Everything here exists because of mobile. Phones and tablets only start a
  // video without a user gesture when it is both muted and inline, and iOS
  // refuses even then in Low Power Mode. Four things follow from that:
  //
  //   1. muted/playsInline are set as PROPERTIES as well as attributes. Some
  //      Safari builds consult the property when deciding whether to allow the
  //      autoplay, and the property is not always populated from the attribute
  //      by the time the first play() runs.
  //   2. The gesture fallback keeps listening until playback is genuinely
  //      running. The previous version used {once:true}, so a tap that landed
  //      while the clip was still buffering burned the only retry and the hero
  //      stayed frozen for the rest of the visit.
  //   3. Clips live in two stacked players that cross-fade. Reloading one
  //      element between clips stalls visibly on a phone, and its play() call
  //      sits outside any gesture, which Low Power Mode rejects.
  //   4. Anyone who asked not to be shown motion, or is on a metered
  //      connection, gets the poster and no download at all.
  function bindHeroVideo() {
    var a = document.getElementById('soa-hero-video');
    if (!a || a.dataset.soaVideoBound) return;
    a.dataset.soaVideoBound = '1';

    var b = document.getElementById('soa-hero-video-b');
    var players = b ? [a, b] : [a];
    var stage = a.closest ? a.closest('.large-header.video') : null;

    var clips = [];
    try { clips = JSON.parse(a.getAttribute('data-clips') || '[]'); } catch (e) { clips = []; }

    function hideVideo() {
      players.forEach(function (v) { v.style.display = 'none'; });
    }

    // Two signals that mean "do not autoplay a background video at this person".
    // Both keep the poster underneath and never fetch the clip.
    var mq = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)');
    var saveData = navigator.connection && navigator.connection.saveData === true;
    if ((mq && mq.matches) || saveData) {
      players.forEach(function (v) {
        v.removeAttribute('autoplay');
        try { v.pause(); } catch (e) {}
      });
      hideVideo();
      return;
    }

    players.forEach(function (v) {
      v.muted = true;
      v.defaultMuted = true;
      v.setAttribute('muted', '');
      v.playsInline = true;
      v.setAttribute('playsinline', '');
      v.setAttribute('webkit-playsinline', '');
    });

    var idx = 0;
    var started = false;
    var failures = 0;

    function current() { return (b && a.classList.contains('is-standby')) ? b : a; }
    function standby() { return (b && a.classList.contains('is-standby')) ? a : b; }

    function attempt(v) {
      if (!v) return null;
      var p;
      try { p = v.play(); } catch (e) { return null; }
      if (p && p.then) p.then(function () { started = true; }, function () {});
      return p;
    }

    var GESTURES = ['touchstart', 'pointerdown', 'click', 'keydown', 'scroll'];
    function detach() {
      GESTURES.forEach(function (ev) { window.removeEventListener(ev, onGesture); });
    }
    function onGesture() {
      var v = current();
      if (v && v.paused) attempt(v);
      if (started) detach();
    }
    GESTURES.forEach(function (ev) {
      window.addEventListener(ev, onGesture, { passive: true });
    });

    players.forEach(function (v) {
      v.addEventListener('playing', function () { started = true; detach(); });
    });

    // Load the next clip into whichever player is not on screen, so the handover
    // is a fade rather than a buffer.
    function preloadNext() {
      var nxt = standby();
      if (!nxt || clips.length < 2) return;
      var url = clips[(idx + 1) % clips.length];
      if (nxt.getAttribute('src') === url) return;
      nxt.setAttribute('src', url);
      nxt.preload = 'auto';
      try { nxt.load(); } catch (e) {}
    }

    // The fade is committed immediately and never waits on play() to settle.
    // Gating it on the promise reads better — the first painted frame would
    // always be a moving one — but it means a play() that hangs or rejects
    // leaves the hero stuck on a finished clip forever, which is exactly the
    // Low Power Mode failure this rewrite exists to remove. Showing a static
    // first frame for one frame is the cheaper failure.
    function advance() {
      if (clips.length < 2 || !b) return;
      var from = current();
      var to = standby();
      idx = (idx + 1) % clips.length;
      attempt(to);
      from.classList.add('is-standby');
      to.classList.remove('is-standby');
      try { from.pause(); from.currentTime = 0; } catch (e) {}
      preloadNext();
    }

    // A Content > Files URL is pasted by hand, so a wrong one is likely. Fall
    // back to the poster rather than leaving a black rectangle, and if only one
    // clip of several is broken, skip to the next.
    function onError(e) {
      var t = e.target;
      var v = t && t.tagName === 'SOURCE' ? t.parentNode : t;
      if (v !== current()) return;
      failures++;
      if (clips.length < 2 || failures >= clips.length) { hideVideo(); return; }
      advance();
    }
    players.forEach(function (v) { v.addEventListener('error', onError, true); });

    players.forEach(function (v) { v.addEventListener('ended', advance); });

    // Off-screen playback is battery spent on nothing, and on a phone the decode
    // competes with scrolling. Resuming on re-entry doubles as another autoplay
    // attempt for anyone the first one was refused for.
    if (stage && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var v = current();
          if (!v) return;
          if (entry.isIntersecting) { if (v.paused) attempt(v); }
          else if (!v.paused) { try { v.pause(); } catch (e) {} }
        });
      }, { threshold: 0.01 }).observe(stage);
    }

    document.addEventListener('visibilitychange', function () {
      var v = current();
      if (!v) return;
      if (document.hidden) { try { v.pause(); } catch (e) {} }
      else if (v.paused) attempt(v);
    });

    if (clips.length > 1) a.removeAttribute('loop');
    attempt(a);
    a.addEventListener('loadeddata', function () { if (a.paused) attempt(a); }, { once: true });
    a.addEventListener('canplay', function () { if (a.paused) attempt(a); }, { once: true });
    preloadNext();
  }

  // The storefront is statically cached, so also hide event cards whose date
  // has passed since the page was rendered.
  function hidePastEvents() {
    var today = new Date().toISOString().slice(0, 10);
    document.querySelectorAll('[data-event-date]').forEach(function (el) {
      var d = el.getAttribute('data-event-date');
      if (d && d < today) el.style.display = 'none';
    });
  }

  // Article contents, built from the rendered body.
  //
  // The body is Shopify rich text, so the headings only exist after render and
  // carry no ids. Doing this here rather than in Liquid means the client writes
  // a normal article in the admin and the anchors appear on their own; asking
  // them to hand-write id attributes in a rich text editor would guarantee they
  // stop existing within two posts.
  function buildToc() {
    var nav = document.getElementById('soa-toc');
    if (!nav || nav.dataset.soaBuilt) return;
    var article = document.querySelector('[data-soa-article] .prose');
    if (!article) return;

    var heads = [].slice.call(article.querySelectorAll('h2'));
    // Under three headings a contents list is noise, not navigation.
    if (heads.length < 3) return;

    var list = nav.querySelector('ol');
    if (!list) return;
    var used = {};
    heads.forEach(function (h, i) {
      var id = h.id;
      if (!id) {
        id = (h.textContent || '').toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '').slice(0, 60);
        if (!id) id = 'section-' + (i + 1);
        if (used[id]) { used[id]++; id = id + '-' + used[id]; } else { used[id] = 1; }
        h.id = id;
      }
      var li = document.createElement('li');
      var a = document.createElement('a');
      a.href = '#' + id;
      a.textContent = h.textContent;
      a.style.cssText = 'color:#4A3328;text-decoration:none;font-size:14.5px;line-height:1.5;border-bottom:1px solid transparent;transition:border-color .3s,color .3s';
      a.setAttribute('data-hover', 'color:#F2A900;border-bottom-color:#F2A900');
      li.appendChild(a);
      list.appendChild(li);
    });
    nav.dataset.soaBuilt = '1';
    nav.removeAttribute('hidden');
    bindStyleStates();
  }

  function init() {
    bindStyleStates();
    bindNav();
    bindReveal();
    initSlideshows();
    bindHeroVideo();
    buildToc();
    hidePastEvents();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // Theme editor: re-bind when a section is re-rendered or a block is selected.
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:block:select', init);
})();
